<ng-container *transloco="let t">
  @let isCardHistoryPre = isShowCard();

  @if (!isCardHistoryPre) {
  <div class="cards-page">
    <div class="cards-page__header cards-page-header">
      <h1 class="title-page cards-page-header__title">
        {{ t('Cards') }}
      </h1>

      <div class="cards-page-toolbar">
        <mat-slide-toggle
          class="cards-page-toggle"
          [ngModel]="store.query().filters.includeDeceased"
          (ngModelChange)="store.toggleDeceased($event)"
        >
          {{ t('Show deceased animals as well') }}
        </mat-slide-toggle>

        <div class="cards-page-actions">
          @if (store.status() === status.Loaded) {
            <button
              (click)="store.startDashboardTour()"
              class="tour-btn gap-xs cards-page-tour-btn"
            >
              <mat-icon class="book-open-blue-icon icon"></mat-icon>
              {{ t('Tour') }}
            </button>

            <button
              mat-stroked-button
              type="button"
              class="cards-page-pdf-btn"
              (click)="generateIntakeFormPdf()"
              [disabled]="isGeneratingIntakePdf()"
              [matTooltip]="t('Generate intake form PDF')"
              [attr.aria-label]="t('Generate intake form PDF')"
            >
              <mat-icon>picture_as_pdf</mat-icon>
            </button>

            <button
              id="add-card"
              mat-flat-button
              (click)="store.openAddNewOwnerDialog()"
              class="primary-btn cards-page-add-btn"
              [disabled]="!store.data()"
            >
              <mat-icon class="plus-icon"></mat-icon>
              {{ t('Add owner and animal card') }}
            </button>
          } @else {
            <div class="cards-page-skeleton">
              <ngx-skeleton-loader
                appearance="circle"
                [theme]="{
                  width: '100%',
                  'border-radius': '10px',
                  height: '44px'
                }"
              ></ngx-skeleton-loader>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="cards-page__search mt-4">
      <div class="justify-content-space-between">
        <form [formGroup]="form">
          <div class="relative rounded-md shadow-sm" style="margin-bottom: 22px; width: 100%">
            <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              <span class="search-icon"></span>
            </div>

            <input formControlName="search" type="text" name="name" id="name"
              class="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary focus:outline-none sm:text-sm sm:leading-6"
              [placeholder]="t('Search by animal name, microchip, owner...')" />

            @if (form.controls.search.value?.length) {
            <button matIconSuffix class="absolute inset-y-0 right-0 flex items-center pr-3" (click)="clearSearch()">
              <mat-icon class="close-icon icon-xs cursor" style="width: 16px; height: 16px"></mat-icon>
            </button>
            }
          </div>

        </form>
      </div>
    </div>

    <div class="cards-page__table-area mx-4 sm:-mx-0" id="card-table">
      <div class="cards-page__table-shell sm:rounded-lg">
        <div #tableWrapper class="table-wrapper table-wrapper--mobile-cards" style="position: relative;" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100"
          [scrollWindow]="false" (scrolled)="loadMore()">

          <anihis-loading-overlay 
            [isLoading]="store.statusSearch() === status.Loading"
            [size]="50"
          />

          @defer (when store.data() ) {
          @if (store.data()?.length! > 0) {

          <div class="mobile-card-list">
            @for (property of store.data(); track property.animalUid) {
              <anihis-animal-card-mobile-card
                [item]="property"
                (addReport)="store.openAddReportDialog(property)"
                (edit)="store.openEditDialog(property)"
                (preview)="openCardPreview(property)"
              />
            }
          </div>

          <mat-table class="min-w-max desktop-only-table" [dataSource]="store.data()!">
               <ng-container matColumnDef="Wanted" sticky>
              <mat-header-cell *matHeaderCellDef class="custom-header" mat-header-cell [matTooltip]="t('Wanted')" matTooltipShowDelay="400">
                <span>{{ t('Wanted') }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let property" mat-cell class="flex flex-row gap-1">
                        @if(property?.lost){
                  <b style="color:red" [matTooltip]="t('Wanted')" matTooltipShowDelay="200" matTooltipPosition="above"
                  [innerHTML]="t('Wanted')  | emptyFallbackHtml"></b>
                        }
               
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Card number" sticky>
              <mat-header-cell *matHeaderCellDef class="custom-header" mat-header-cell [matTooltip]="t('Animal card number')" matTooltipShowDelay="400">
                <span>{{ t('Animal card number') }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let property" mat-cell class="flex flex-row gap-1">
                <span [matTooltip]="
                          t(property?.exitusLetalis ? 'Exitus Letalis' : 'Alive')
                        " matTooltipShowDelay="200" matTooltipPosition="above" [ngClass]="
                          property?.exitusLetalis ? 'exitusLetalis' : 'alive'
                        "></span>
                <span [matTooltip]="property?.cartonNumber" matTooltipShowDelay="200" matTooltipPosition="above"
                  [innerHTML]="property?.cartonNumber | emptyFallbackHtml"></span>
              </mat-cell>
            </ng-container>

            <!-- Owner Column -->
            <ng-container matColumnDef="Name" sticky>
              <mat-header-cell *matHeaderCellDef class="custom-header" mat-header-cell [matTooltip]="t('Animal name')" matTooltipShowDelay="400">
                <span>{{ t('Animal name') }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let property" mat-cell class="flex flex-row gap-1">
                <mat-chip class="chip-grey">
                  <div class="flex gap-s">
                   

                    <span class="truncate max-w-[190px] block" [matTooltip]="property?.name" matTooltipShowDelay="200"
                      matTooltipPosition="above" [innerHTML]="property?.name | emptyFallbackHtml"></span>
                  </div>
                </mat-chip>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Breed">
              <mat-header-cell *matHeaderCellDef class="custom-header" mat-header-cell [matTooltip]="t('Animal breed')" matTooltipShowDelay="400">
                <span>{{ t('Animal breed') }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let property" mat-cell class="flex flex-row gap-1">
                <span [matTooltip]="property?.breed?.name | transloco" matTooltipShowDelay="200" matTooltipPosition="above"
                  [innerHTML]="property?.breed?.name | transloco | emptyFallbackHtml"></span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Gender">
              <mat-header-cell *matHeaderCellDef class="custom-header" mat-header-cell [matTooltip]="t('Animal gender')" matTooltipShowDelay="400">
                <span>{{ t('Animal gender') }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let property" mat-cell class="flex flex-row gap-1">
                <span [innerHTML]="t(property?.gender) | emptyFallbackHtml"></span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Date Of Birth">
              <mat-header-cell *matHeaderCellDef class="custom-header" mat-header-cell [matTooltip]="t('Animal date of birth')" matTooltipShowDelay="400">
                <span>{{ t('Animal date of birth') }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let property" mat-cell class="flex flex-row gap-1">
                <span [innerHTML]="
                          property?.birthDateTime
                            ? (property.birthDateTime | localDate)
                            : (property?.birthDateText || '')
                            | emptyFallbackHtml
                        "></span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Microchip">
              <mat-header-cell *matHeaderCellDef class="custom-header" mat-header-cell [matTooltip]="t('Animal microchip')" matTooltipShowDelay="400">
                <span>{{ t('Animal microchip') }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let property" mat-cell class="flex flex-row gap-1">
                <span [innerHTML]="property?.microchip | emptyFallbackHtml"></span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Owner name">
              <mat-header-cell *matHeaderCellDef class="custom-header" mat-header-cell [matTooltip]="t('Owner name')" matTooltipShowDelay="400">
                <span>{{ t('Owner name') }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let property" mat-cell class="flex flex-row gap-1">
                <span [matTooltip]="
                          property?.owner?.firstName +
                          ' ' +
                          property?.owner?.lastName
                        " matTooltipShowDelay="200" matTooltipPosition="above">
                  {{
                  property?.owner?.firstName +
                  ' ' +
                  property?.owner?.lastName
                  }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Address">
              <mat-header-cell *matHeaderCellDef class="custom-header" mat-header-cell [matTooltip]="t('Owner address')" matTooltipShowDelay="400">
                <span>{{ t('Owner address') }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let property" mat-cell class="flex flex-row gap-1">
                <span [matTooltip]="
                          (property?.owner?.contact?.street
                            ? property?.owner?.contact?.street + ', '
                            : '') +
                          (property?.owner?.contact?.city
                            ? property?.owner?.contact?.city + ', '
                            : '') +
                          ' ' +
                          (property?.owner?.contact?.country
                            ? property?.owner?.contact?.country + ' '
                            : '')
                        " matTooltipShowDelay="200" matTooltipPosition="above">
                  {{
                  (property?.owner?.contact?.street
                  ? property?.owner?.contact?.street + ', '
                  : '') +
                  (property?.owner?.contact?.city
                  ? property?.owner?.contact?.city + ', '
                  : '') +
                  ' ' +
                  (property?.owner?.contact?.country
                  ? property?.owner?.contact?.country + ' '
                  : '')
                  }}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Email">
              <mat-header-cell *matHeaderCellDef class="custom-header" mat-header-cell [matTooltip]="t('Owner email')" matTooltipShowDelay="400">
                <span>{{ t('Owner email') }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let property" mat-cell class="flex flex-row gap-1">
                <span [matTooltip]="property?.owner?.email" matTooltipShowDelay="200" matTooltipPosition="above"
                  [innerHTML]="property?.owner?.email | emptyFallbackHtml"></span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Mobile number">
              <mat-header-cell *matHeaderCellDef class="custom-header" mat-header-cell [matTooltip]="t('Owner mobile number')" matTooltipShowDelay="400">
                <span>{{ t('Owner mobile number') }}</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let property" mat-cell class="flex flex-row gap-1">
                <span [matTooltip]="property?.owner?.contact?.mobileNumber" matTooltipShowDelay="200"
                  matTooltipPosition="above" [innerHTML]="
                          property?.owner?.contact?.mobileNumber
                            | emptyFallbackHtml
                        "></span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Actions" stickyEnd>
              <mat-header-cell *matHeaderCellDef mat-header-cell>
                <!-- <span>{{ t('Actions') }}</span> -->
              </mat-header-cell>
              <mat-cell *matCellDef="let property; let i = index" mat-cell class="flex flex-row gap-1" [ngClass]="{
                             'sticky-actions-last': i === (store.data()?.length ?? 0) - 1
                      }" (click)="$event.stopPropagation()">
                <div class="flex gap-3 justify-center" id="card-actions">
                  @if (!property?.exitusLetalis) {
                  <button [matTooltip]="t('Add report')" matTooltipShowDelay="200" matTooltipPosition="above"
                    (click)="store.openAddReportDialog(property)" class="flex items-center justify-center" [attr.aria-label]="t('Add report')">
                    <mat-icon class="add-white-icon icon-s"></mat-icon>
                  </button>
                  } @else {
                  <div style="width: 24px"></div>
                  }

                  <button [matTooltip]="t('Edit owner / animal')" matTooltipShowDelay="200" matTooltipPosition="above"
                    (click)="store.openEditDialog(property)" class="flex items-center justify-center" [attr.aria-label]="t('Edit owner / animal')">
                    <mat-icon class="edit-white-icon icon-s"></mat-icon>
                  </button>

                  <button [matTooltip]="t('Preview card')" matTooltipShowDelay="200" matTooltipPosition="above"
                    (click)="openPreviewDialog($event, property)" class="flex items-center justify-center" [attr.aria-label]="t('Preview card')">
                    <mat-icon class="preview-white-icon icon-s"></mat-icon>
                  </button>
                </div>
              </mat-cell>
            </ng-container>

            <!-- Row Definitions -->
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedColumns" (click)="openPreviewDialog($event, row)" class="cursor-pointer"></mat-row>
          </mat-table>

          @if (store.status() === status.Loading && store.statusSearch() !== status.Loading) {
          <div class="centered-message mt-4">
            <anihis-loading-spinner [size]="'small'"></anihis-loading-spinner>
          </div>
          }
          } @else {
          <div class="centered-message mt-4">
            {{ t('You have no cards') }}
          </div>
          }
          } @placeholder {
          <div class="scroll-hidden">
            <anihis-loading-skeleton [height]="'65dvh'" [minWidth]="'100%'" />
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  } @else {
  <anihis-card-history (backEvent)="showCardHistory()" [cardData]="cardData"></anihis-card-history>
  }
</ng-container>

<anihis-tour-overlay />